import { ClusterLayer, type ClusterProps } from './cluster-layer'

export function ClustersSmall(props: ClusterProps) {
	return <ClusterLayer {...props} size="small" />
}
